export const BoneLossSvg = () => {
  return (
    <div className="vai-flex vai-items-end">
      <svg
        width="4"
        height="10"
        viewBox="0 0 4 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="2.20266"
          y1="2.55371"
          x2="2.20266"
          y2="9.75513"
          stroke="#22C55E"
          strokeWidth="1.20024"
          strokeDasharray="1.2 1.2"
        />
        <path
          d="M2.20313 1.19336C2.67639 1.19359 3.05957 1.57746 3.05957 2.05078C3.05934 2.5239 2.67625 2.907 2.20313 2.90723C1.72981 2.90723 1.34593 2.52405 1.3457 2.05078C1.3457 1.57732 1.72967 1.19336 2.20313 1.19336Z"
          fill="#22C55E"
          stroke="#22C55E"
          strokeWidth="1.80036"
        />
      </svg>
      <svg
        width="5"
        height="13"
        viewBox="0 0 5 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="2.66945"
          y1="3.20117"
          x2="2.66945"
          y2="12.8031"
          stroke="#D4A700"
          strokeWidth="1.20024"
          strokeDasharray="1.2 1.2"
        />
        <path
          d="M2.66992 1.8418C3.14319 1.84203 3.52637 2.2259 3.52637 2.69922C3.52614 3.17234 3.14304 3.55543 2.66992 3.55566C2.1966 3.55566 1.81273 3.17248 1.8125 2.69922C1.8125 2.22576 2.19646 1.8418 2.66992 1.8418Z"
          fill="#D4A700"
          stroke="#D4A700"
          strokeWidth="1.80036"
        />
      </svg>
      <svg
        width="4"
        height="15"
        viewBox="0 0 4 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="2.13527"
          y1="2.80078"
          x2="2.13527"
          y2="14.8032"
          stroke="#F97316"
          strokeWidth="1.20024"
          strokeDasharray="1.2 1.2"
        />
        <path
          d="M2.13574 1.44141C2.60901 1.44164 2.99219 1.82551 2.99219 2.29883C2.99196 2.77195 2.60886 3.15504 2.13574 3.15527C1.66242 3.15527 1.27855 2.77209 1.27832 2.29883C1.27832 1.82537 1.66228 1.44141 2.13574 1.44141Z"
          fill="#F97316"
          stroke="#F97316"
          strokeWidth="1.80036"
        />
      </svg>
      <svg
        width="5"
        height="17"
        viewBox="0 0 5 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="2.60207"
          y1="2.35205"
          x2="2.60207"
          y2="16.7549"
          stroke="#EF4444"
          strokeWidth="1.20024"
          strokeDasharray="1.2 1.2"
        />
        <path
          d="M2.60254 0.992188C3.0758 0.992418 3.45898 1.37629 3.45898 1.84961C3.45875 2.32273 3.07566 2.70583 2.60254 2.70606C2.12922 2.70606 1.74535 2.32287 1.74512 1.84961C1.74512 1.37615 2.12908 0.992188 2.60254 0.992188Z"
          fill="#EF4444"
          stroke="#EF4444"
          strokeWidth="1.80036"
        />
      </svg>
    </div>
  );
};
